import React from "react";

const PUB = process.env.PUBLIC_URL || "";

// Official ":-D" glyph geometry (Lato Heavy, converted to path). viewBox 420x280.
const SMILE_PATH =
  "m 57.31,191.225 q 0,-3.135 1.14,-5.89 1.235,-2.85 3.325,-4.845 2.09,-2.09 4.845,-3.23 2.85,-1.235 6.175,-1.235 3.23,0 6.08,1.235 2.85,1.14 4.94,3.23 2.09,1.995 3.23,4.845 1.235,2.755 1.235,5.89 0,3.23 -1.235,5.985 -1.14,2.755 -3.23,4.845 -2.09,1.995 -4.94,3.135 -2.85,1.14 -6.08,1.14 -3.325,0 -6.175,-1.14 -2.755,-1.14 -4.845,-3.135 -2.09,-2.09 -3.325,-4.845 -1.14,-2.755 -1.14,-5.985 z m 0,-66.5 q 0,-3.135 1.14,-5.89 1.235,-2.85 3.325,-4.845 2.09,-2.09 4.845,-3.23 2.85,-1.235 6.175,-1.235 3.23,0 6.08,1.235 2.85,1.14 4.94,3.23 2.09,1.995 3.23,4.845 1.235,2.755 1.235,5.89 0,3.23 -1.235,5.985 -1.14,2.755 -3.23,4.845 -2.09,1.995 -4.94,3.135 -2.85,1.14 -6.08,1.14 -3.325,0 -6.175,-1.14 -2.755,-1.14 -4.845,-3.135 -2.09,-2.09 -3.325,-4.845 -1.14,-2.755 -1.14,-5.985 z m 42.634939,11.97 h 50.160001 v 21.47 H 99.944939 Z M 290.5901,136.03 q 0,15.105 -5.13,27.835 -5.035,12.635 -14.345,21.755 -9.215,9.12 -22.23,14.25 -13.015,5.13 -28.88,5.13 h -53.01 V 67.155 h 53.01 q 15.865,0 28.88,5.13 13.015,5.13 22.23,14.345 9.31,9.12 14.345,21.755 5.13,12.635 5.13,27.645 z m -29.26,0 q 0,-10.83 -2.85,-19.475 -2.85,-8.645 -8.17,-14.63 -5.32,-5.985 -13.015,-9.215 -7.6,-3.23 -17.29,-3.23 h -24.32 v 93.195 h 24.32 q 9.69,0 17.29,-3.135 7.695,-3.23 13.015,-9.215 5.32,-6.08 8.17,-14.725 2.85,-8.645 2.85,-19.57 z";

/**
 * Official Diallo ":-D" smile mark (standalone symbol). Aspect ratio 3:2.
 * `size` = width in px; height scales automatically.
 */
export const SmileMark = ({ color = "#ED1C24", size = 60, className = "" }) => (
  <svg
    width={size}
    height={(size * 280) / 420}
    viewBox="0 0 420 280"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path d={SMILE_PATH} fill={color} />
  </svg>
);

/** Rounded-square ":-D" badge (icon for compact spaces). */
export const SmileBadge = ({ size = 44, bg = "#ED1C24", fg = "#FFFFFF", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <rect x="20" y="20" width="360" height="360" rx="72" fill={bg} />
    <g transform="translate(17,65)">
      <path d={SMILE_PATH} fill={fg} />
    </g>
  </svg>
);

/**
 * Official Diallo horizontal wordmark (image asset).
 * Brand rule: horizontal spaces use the wordmark ONLY — never beside the :-D symbol.
 * variant: 'red' (light bg) | 'white' (dark/red bg). `className` controls height.
 */
export const Wordmark = ({ variant = "red", className = "h-7" }) => {
  const src = variant === "white" ? "diallo_horizontal_white.svg" : "diallo_horizontal_red.svg";
  return <img src={`${PUB}/brand/${src}`} alt="Diallo" className={`w-auto ${className}`} draggable="false" />;
};

export default Wordmark;
